// import Vue from 'vue'
import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { productAddedCartModel, productModel, productType } from "@/models/productModel";
import { mediaType, mediaModel } from "@/models/mediaModel";
import { sisasListiniModel } from "@/models/sisasPimListiniModel";
import { optionModel, iProductOption } from "@/models/optionModel";
import domainService from "@/services/domainService";
import { CustomerInfoModel } from "@/models/customerModels";
import baseUserContexetProductComponent from "@/components/baseUserContextProductComponent";
import { familyOptionViewModel } from "@/models/familyOptionModel";
import { productRelation } from "@/models/productRelation";
import eventHub from "@/eventHub";
import axios from "axios";
import { mapGetters } from "vuex";
import { umDefinition } from "@/models/umDefinition";
import { ShoppingCartModel } from "@/models/shoppingCartModel";

@Component({
    // computed: {
    //     ...mapGetters(["getWindowSize"])
    // }
})
export default class productInfoDetail extends baseUserContexetProductComponent {
    // @Prop({ default: () => [] })
    relations: productRelation[] = [];
    isAddingProduct: boolean = false;
    // @Prop({ default: () => false })
    isLoadingRelations: boolean = false;
    @Prop({ default: () => new productModel() })
    item: productModel;

    buyTogetherItems: number[] = [];

    @Watch("item", { deep: true })
    onProductChange(newVal: any) {
        var instance = this;
        instance.fetchRelations();
    }

    created() {}
    beforeMount() {}
    mounted() {
        var instance = this;
        instance.fetchRelations();
        eventHub.$on(eventHub.events.CURRENT_CUSTOMER_CHANGED, instance.checkCurrentCustomer);
        //     this.$nextTick(() => {
        //       instance.changeWindowsSize++; // Aggiungi l'ascoltatore dell'evento resize
        //     });
    }
    beforeDestroy() {
        var instance = this;
        eventHub.$off(eventHub.events.CURRENT_CUSTOMER_CHANGED, instance.checkCurrentCustomer);
    }

    //getWindowSize!: any;
    showCustomerModal: boolean = false;
    showAddToCartModal: boolean = false;
    get showAddToCartModal_LoadingCheck(): boolean {
        return this.showAddToCartModal && this.isLoadingRelations == false;
    }
    set showAddToCartModal_LoadingCheck(v: boolean) {
        this.showAddToCartModal = v;
    }
    // selectedProduct: productModel = null;
    // get productToAdd(): productModel {
    //   var instance = this;
    //   return instance.showAddToCartModal_LoadingCheck ? instance.selectedProduct : null;
    // }
    selectedProductId: number = null;
    get selectedProduct(): productModel {
        var instance = this;
        if (instance.selectedProductId == null) return null;
        var r = (instance.relations || []).find((x) => x.product != null && x.product.id == instance.selectedProductId);
        return r == null ? null : r.product;
    }
    goToDetail(section: string) {
        let element = document.getElementById(section);
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        // element.scrollTop -= 500;

        // var elem = this.$refs[section];
        // if (elem != null && (elem as Element[]).length > 0) {
        //    var top = (elem[0] as any).offsetTop;
        //    window.scrollTo(0, top);
        // }
    }
    imageIndex: number = 0;
    get images() {
        var instance = this;
        var images = [];

        if (instance.item != null && instance.item.media != null) {
            images = instance.item.media.filter((x) => x.mediaType == mediaType.Image);
        }

        return images.sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1));
    }
    get optionToShow(): iProductOption[] {
        var instance = this;
        return instance.item == null ? [] : instance.item.options;
    }
    get familyOptionToShow(): familyOptionViewModel[] {
        var instance = this;
        return instance.item == null ? [] : instance.item.familyOptions.filter((x) => x.groupCode == "B2BTABS" && instance.hasOptionValue(x.code, instance.item));
    }
    get selectedImage(): mediaModel {
        var instance = this;
        if (instance.item == null || instance.images.length == 0 || instance.images.length < instance.imageIndex) return new mediaModel();
        else return instance.images[instance.imageIndex];
    }
    isSelected(image: mediaModel, index: number) {
        return this.imageIndex == index;
    }
    setImage(image: mediaModel, index: number) {
        return (this.imageIndex = index);
    }

    get skus(): string[] {
        var instance = this;
        if (instance.item == null) return [];

        var skus = [];
        skus.push(instance.item.sku);
        return skus;
    }
    checkCurrentCustomer() {
        var instance = this;
        // if (instance.getCurrentCustomerId == null)
        instance.fetchRelations();
    }
    get accessories(): productRelation[] {
        var instace = this;
        return instace.relations == null ? [] : instace.relations.filter((x) => x.relationType == "ACCESSORY").sort((a, b) => (a.displayOrder >= b.displayOrder ? 1 : 0));
    }

    get accessoriesProducts(): any[] {
        var instace = this;

        if (this.accessories.length) {
            return this.accessories.map((item) => item.product);
        }

        return [];
    }

    get upselling(): productRelation[] {
        var instace = this;
        return instace.relations == null ? [] : instace.relations.filter((x) => x.relationType == "UPSELLING").sort((a, b) => (a.displayOrder >= b.displayOrder ? 1 : 0));
    }

    get upsellingProducts(): any[] {
        var instace = this;

        if (this.upselling.length) {
            return this.upselling.map((item) => item.product);
        }

        return [];
    }

    get buyTogether() {
        var instace = this;
        return instace.relations == null ? [] : instace.relations.filter((x) => x.relationType == "BUY-TOGETHER").sort((a, b) => (a.displayOrder >= b.displayOrder ? 1 : 0));

        /*
        var buyTogetherRelation = instace.relations == null ? [] : instace.relations.filter((x) => x.relationType == "BUY-TOGETHER").sort((a, b) => (a.displayOrder >= b.displayOrder ? 1 : 0));
        var results = [];
        for(var i = 0; i < buyTogetherRelation.length; i++) {
            var prd = buyTogetherRelation[i].product;
            if (prd) {
                if (!("buyTogetherSelected" in prd)) {
                    Vue.set(prd, "buyTogetherSelected", true);
                }
            }
            results.push(buyTogetherRelation[i]);
        }

        return results;
        */
    }

    get buyTogetherProducts(): any[] {
        if (this.buyTogether.length) {
            var results = [this.item];

            var buyTProducts = this.buyTogether.map((item) => item.product);

            for (var i = 0; i < buyTProducts.length; i++) {
                var prd = buyTProducts[i];
                results.push(prd);
            }

            return results;
        }

        return [];
    }

    get crosselling(): productRelation[] {
        var instace = this;
        return instace.relations == null ? [] : instace.relations.filter((x) => x.relationType == "CROSSELLING").sort((a, b) => (a.displayOrder >= b.displayOrder ? 1 : 0));
    }
    get crossellingProducts(): any[] {
        var instace = this;

        if (this.crosselling.length) {
            return this.crosselling.map((item) => item.product);
        }

        return [];
    }

    get showComponent(): boolean {
        var instance = this;
        return (instance.familyOptionToShow != null && instance.familyOptionToShow.length > 0) || instance.accessories.length > 0 || instance.upselling.length > 0 || instance.crosselling.length > 0;
    }
    onSelectCustomer(customer: CustomerInfoModel) {
        var instance = this;
        eventHub.$on(eventHub.events.CURRENT_CUSTOMER_CHANGED, instance.openAddToCartModal_after_event_CustomerChanged);

        instance.setCurrentCustomer(customer);
    }
    openAddToCartModal_after_event_CustomerChanged() {
        var instance = this;
        instance.showCustomerModal = false;
        if (instance.selectedProduct != null) instance.showAddToCartModal = true;
        eventHub.$off(eventHub.events.CURRENT_CUSTOMER_CHANGED, instance.openAddToCartModal_after_event_CustomerChanged);
    }
    onSelectProduct(p: productModel) {
        var instance = this;
        instance.selectedProductId = p.id;
        if (instance.getCurrentCustomer == null) {
            instance.showCustomerModal = true;
        } else {
            instance.showAddToCartModal = true;
        }
    }
    fetchRelations() {
        var instance = this;

        if (instance.item != null && instance.item.id != null) {
            instance.isLoadingRelations = true;
            axios
                .get<productRelation[]>("/product/relations", {
                    params: {
                        productId: instance.item.id,
                        loadListini: true,
                        customerId: instance.getCurrentCustomerId
                    }
                })
                .then((res) => {
                    instance.buyTogetherItems = [];
                    instance.relations = res.data || [];

                    var existBuyTogether = instance.relations.find((item) => {
                        return item && item.relationType == "BUY-TOGETHER";
                    });
                    if (existBuyTogether) {
                        var relationsBuyTogether = instance.relations.filter((item) => {
                            return item && item.relationType == "BUY-TOGETHER";
                        });

                        for (var i = 0; i < relationsBuyTogether.length; i++) {
                            let prd = relationsBuyTogether[i].product;
                            if (prd) {
                                instance.buyTogetherItems.push(prd.id);
                            }
                        }

                        instance.buyTogetherItems.push(instance.item.id);
                    }

                    instance.isLoadingRelations = false;
                })
                .catch((err) => {
                    instance.isLoadingRelations = false;
                });
        } else {
            instance.relations = [];
        }
    }

    get totaleProdottiAcquistabiliInsieme(): number {
        var tot = 0;

        for (var i = 0; i < this.buyTogetherItems.length; i++) {
            var idProduct = this.buyTogetherItems[i];
            var prd = this.buyTogetherProducts.find((item) => {
                return item.id == idProduct;
            });

            if (prd) {
                var umD = this.getUmsDefinition(prd);

                var umdS = umD.filter((item) => item.fattore == 1);

                if (umdS && umdS.length) {
                    tot += umdS[0].prezzoUnitario;
                }
            }
        }

        return tot;
    }

    prezzoUnitarioProdotto(prd): number {
        var tot = 0;
        try {
            if (prd) {
                var umD = this.getUmsDefinition(prd);

                var umdS = umD.filter((item) => item.fattore == 1);

                if (umdS && umdS.length) {
                    tot = umdS[0].prezzoUnitario;
                }
            }
        }
        catch(ex) {
            tot = 0;
        }

        return tot;
    }

    async showModalCustomerOrAdd() {
        if (this.getCurrentCustomer == null) {
            this.showCustomerModal = true;
        } else {
            var instance = this;
            if (this.buyTogetherItems.length) {
                this.isAddingProduct = true;
                var addedProdutcs = [];
                var res = null;
                
                for (var i = 0; i < this.buyTogetherItems.length; i++) {
                    var productId = this.buyTogetherItems[i];
                    var rel: any = this.buyTogether.find(x => {
                        return x.childProductId == productId;
                    });

                    var defaultQuantity = 1;
                    if (rel && rel.defaultQuantity) {
                        defaultQuantity = rel.defaultQuantity;
                    }

                    var product = this.buyTogetherProducts.find((item) => {
                        return item.id == productId;
                    });

                    if (product) {
                        var pacm = new productAddedCartModel();
                        pacm.product = product;
                        pacm.quantity = defaultQuantity;
                        pacm.source = "addToCartPanel";
                        pacm.added = true;
                        addedProdutcs.push(pacm);

                        await axios
                            .post<ShoppingCartModel>(`cart/addproduct`, {
                                customerId: instance.getCurrentCustomerId,
                                productId: product.id,
                                quantity: defaultQuantity,
                                note: ""
                            })
                            .then((response) => {
                                res = response;
                            })
                            .catch((error) => {
                                console.error(error);
                            });
                    }
                }

                instance.setCurrentCart(res.data);
                instance.isAddingProduct = false;

                eventHub.$emit(eventHub.events.CART_UPDATED, addedProdutcs);
                instance.$emit("added", addedProdutcs);
            }
        }
    }

    getSubTitle(product: productModel): string {
        if (product == null) return "";
        if (product.type != productType.Configurable) return `Codice ${product.sku}`;
        return product.sku;
    }

    getTitle(product: productModel): string {
        if (product != null && product.name != null) return product.name["it-IT"];
        return "";
    }

    goToProductDetail(product: productModel): string {
        this.$router.push({ path: "/product/" + product.id });
    }

    get hasListino() {
        var buyTogetherProductsHasListini = this.buyTogetherProducts.length > 0;
        for (var i = 0; i < this.buyTogetherProducts.length; i++) {
            var prd = this.buyTogetherProducts[i];

            if (prd.listini && prd.listini.length) {
            } else {
                return false;
            }
        }

        return buyTogetherProductsHasListini;
    }

    onBuyTogetherProductChange(event, productId) {
        if (this.buyTogetherItems.includes(productId)) {
            let index = this.buyTogetherItems.indexOf(productId);
            if (index > -1) {
                this.buyTogetherItems.splice(index, 1);
            }
        } else {
            this.buyTogetherItems.push(productId);
        }
    }
}
